import React from "react";
import { useTranslation } from "react-i18next";
import info1 from "../images/info_icon1.svg";
import info2 from "../images/info_icon2.png";
import info3 from "../images/info_icon3.svg";

const Info = () => {
  const { t } = useTranslation();

  return (
    <div className="info_content">
      <div data-aos="zoom-in-right" data-aos-anchor-placement="top-bottom">
        <div className="info_box">
          <div className="info_logo">
            <img src={info1} alt="info1" />
          </div>
          <div className="info_text">
            <h4>{t("INFO.CONTACT")}</h4>
            <p>+998 99 229-20-20</p>
          </div>
        </div>
      </div>

      <div data-aos="zoom-out" data-aos-anchor-placement="top-bottom">
        <div className="info_box">
          <div className="info_logo">
            <img src={info2} alt="info2" />
          </div>
          <div className="info_text">
            <h4>{t("INFO.ADDRESS")}</h4>
            <p>{t("INFO.ADDRESS_TEXT")}</p>
          </div>
        </div>
      </div>

      <div data-aos="zoom-in-left" data-aos-anchor-placement="top-bottom">
        <div className="info_box">
          <div className="info_logo">
            <img src={info3} alt="info3" />
          </div>
          <div className="info_text">
            <h4>{t("INFO.EMAIL")}</h4>    
            <p>yuksalish.socks2016@gmail.com</p>
          </div>    
        </div>
      </div>
    </div>
  );
};

export default Info;
